import React from 'react'
import { Trans, withTranslation } from 'react-i18next'
import Link from 'react-router-dom/Link'
import Icon from 'srcReact/components/icons/Icon'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'

function OrganizationTerms({ t }) {
  return (
    <PageContainer pageTitle={t('organization.terms.pageTitle')} withFooter={false}>
      <div className={styles.termsWrapper}>
        <Trans>
          <div className={styles.termsTitle}>
            <Link to='/0/create-organization' className={styles.backLink}>
              <Icon name='arrow-left24' size='large32' alt={t('organization.terms.backAltText')} />
            </Link>
            <h1 className={styles.heading}>{t('organization.terms.title')}</h1>
          </div>
          <div className={styles.termsContent}>
            <div className={styles.content}>
              <p className={styles.effectiveDate}>{t('organization.terms.effectiveDate')}</p>
              {/* Welcome to MixR! */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionWelcome.title')}</strong>
              </h3>
              <p>{t('organization.terms.sectionWelcome.p1')}</p>
              <h4 className={styles.subHeading4}>{t('organization.terms.sectionWelcome.agreementDefination.title')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('organization.terms.sectionWelcome.agreementDefination.p1') }} />
              <p dangerouslySetInnerHTML={{ __html: t('organization.terms.sectionWelcome.agreementDefination.p2') }} />
              <h4 className={styles.subHeading4}>{t('organization.terms.sectionWelcome.contractOnBehalf.title')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('organization.terms.sectionWelcome.contractOnBehalf.p1') }} />
              {/* Customer options and instructions */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionOptionsInstructions.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.whoIsCustomer.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.whoIsCustomer.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.signupUsingCorpEmail.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.signupUsingCorpEmail.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.meaningForCustAndUs.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.meaningForCustAndUs.p1')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.meaningForCustAndUs.p2')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.subscriptionRequests.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.subscriptionRequests.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.purchaseDecisions.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.purchaseDecisions.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.feedbackIsWelcome.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.feedbackIsWelcome.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOptionsInstructions.privacyPolicy.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOptionsInstructions.privacyPolicy.p1')
                }}
              />
              {/* Customer and Authorized Users */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionCustomerAuthorizedUsers.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionCustomerAuthorizedUsers.useOfServices.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionCustomerAuthorizedUsers.useOfServices.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionCustomerAuthorizedUsers.removalRights.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionCustomerAuthorizedUsers.removalRights.p1')
                }}
              />
              {/* Payment obligations*/}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionPaymentObligations.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionPaymentObligations.paymentCondition.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionPaymentObligations.paymentCondition.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionPaymentObligations.fairBillingPolicy.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionPaymentObligations.fairBillingPolicy.p1')
                }}
              />
              <h4 className={styles.subHeading4}>{t('organization.terms.sectionPaymentObligations.credits.title')}</h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionPaymentObligations.credits.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionPaymentObligations.defaultDowngrade.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionPaymentObligations.defaultDowngrade.p1')
                }}
              />
              {/* Our responsibilities */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionOurResponsibilities.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOurResponsibilities.servicesProvision.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOurResponsibilities.servicesProvision.p1')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOurResponsibilities.servicesProvision.p2')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOurResponsibilities.customerDataProtection.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOurResponsibilities.customerDataProtection.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOurResponsibilities.extendedFamily.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOurResponsibilities.extendedFamily.p1')
                }}
              />
              {/* Ownership and property rights */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionOwnershipPropertyRights.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOwnershipPropertyRights.WhatsYoursIsYours.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOwnershipPropertyRights.WhatsYoursIsYours.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionOwnershipPropertyRights.WhatsOursIsOurs.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionOwnershipPropertyRights.WhatsOursIsOurs.p1')
                }}
              />
              {/* Term and termination */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionTermTermination.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.contractTerm.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.contractTerm.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.automaticRenewal.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.automaticRenewal.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.justCauseTermination.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.justCauseTermination.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.withoutCauseTermination.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.withoutCauseTermination.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.effectOfTermination.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.effectOfTermination.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionTermTermination.dataPortabilityDeletion.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionTermTermination.dataPortabilityDeletion.p1')
                }}
              />
              {/* Disclaimer of Warranty Representations */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionWarrantyRepresentations.title')}</strong>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionWarrantyRepresentations.p1')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionWarrantyRepresentations.p2')
                }}
              />
              {/* Limitation of Liability */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionLiabilityLimitation.title')}</strong>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionLiabilityLimitation.p1')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionLiabilityLimitation.p2')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionLiabilityLimitation.p3')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionLiabilityLimitation.p4')
                }}
              />
              {/* Our Indemnification of Customer */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionCustomerIndemnification.title')}</strong>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionCustomerIndemnification.p1')
                }}
              />
              {/* Customer’s Indemnification of Us */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>
                  {t('organization.terms.sectionCustomerIndemnificationOfUs.title')}
                </strong>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionCustomerIndemnificationOfUs.p1')
                }}
              />
              {/* Limitations of Indemnifications*/}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>
                  {t('organization.terms.sectionLimitationsOfIndemnifications.title')}
                </strong>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionLimitationsOfIndemnifications.p1')
                }}
              />
              {/* Confidentiality*/}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionConfidentiality.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionConfidentiality.confidentialInformation.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionConfidentiality.confidentialInformation.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionConfidentiality.protectionOfConfidentialInfo.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionConfidentiality.protectionOfConfidentialInfo.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionConfidentiality.disclosureForcedAccess.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionConfidentiality.disclosureForcedAccess.p1')
                }}
              />
              <h4 className={styles.subHeading4}>{t('organization.terms.sectionConfidentiality.validity.title')}</h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionConfidentiality.validity.p1')
                }}
              />
              {/* General provisions */}
              <h3 className={styles.subHeading3}>
                <strong className={styles.bold}>{t('organization.terms.sectionGeneralProvisions.title')}</strong>
              </h3>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.advertising.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.advertising.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.forceMajeure.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.forceMajeure.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.relationshipOfParties.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.relationshipOfParties.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.mixrEmailMessage.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.mixrEmailMessage.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.modifications.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.modifications.p1')
                }}
              />
              <h4 className={styles.subHeading4}>{t('organization.terms.sectionGeneralProvisions.renounce.title')}</h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.renounce.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.divisibility.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.divisibility.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.assignment.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.assignment.p1')
                }}
              />
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.applicableLaw.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.applicableLaw.p1')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.applicableLaw.p2')
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.applicableLaw.p3')
                }}
              />
              <h5>{t('organization.terms.sectionGeneralProvisions.applicableLaw.addressTitle')}</h5>
              <p className={styles.address}>{t('organization.terms.sectionGeneralProvisions.applicableLaw.address')}</p>
              <h4 className={styles.subHeading4}>
                {t('organization.terms.sectionGeneralProvisions.completeAgreement.title')}
              </h4>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('organization.terms.sectionGeneralProvisions.completeAgreement.p1')
                }}
              />
            </div>
          </div>
        </Trans>
      </div>
    </PageContainer>
  )
}

const ExtendedComponent = withTranslation('common')(OrganizationTerms)
export { ExtendedComponent as OrganizationTerms }
